import { connect } from "react-redux"

import { setImplicitCategory, setHovered } from "src/actions/storesActions"
import { Category } from "src/types"

import Picks from "./Picks"

const mapStateToProps = (state, { pageContext }) => ({
  ...state.stores,
  ...state.screen,
  ...pageContext,
})

const mapDispatchToProps = (dispatch) => {
  return {
    setImplicitCategory: (category?: Category) => {
      dispatch(setImplicitCategory(category))
    },
    setHovered: (id: string | null) => {
      dispatch(setHovered(id))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Picks)
